import { AddressForm } from '../global-types';
import { AddressData } from '../global-types/addresses';
import { mapAddressesByType, MappedAddresses } from './address/map-address-by-type';
import { trimObjectStrings } from './trim-object-strings';

export const buildOneToOneAddresses = (address: AddressForm): MappedAddresses<AddressData> | null => {
  if (address === null) {
    return null;
  }

  // remove unused keys from address object
  delete address?.send_to;
  delete address?.envelope;

  // trim all the strings in the address object
  const trimmedAddress = trimObjectStrings(address) as AddressForm;

  // map the trimmed address object to the correct address type
  return mapAddressesByType([{ ...trimmedAddress }]);
};
